import { FunctionComponent, ReactNode } from 'react';

import { Header } from '../Header/Header';
import { PanelOverlay } from '../PanelOverlay/PanelOverlay';
import { CustomBackground } from './CustomBackground.styled';
import { InnerPanelWrapper } from './InnerPanelWrapper.styled';

export interface ChatPanelProps {
  initialWidth?: number;
  customBackground?: ReactNode;
  className?: string;
  show: boolean;
  stopAnimation?: boolean;
  children: ReactNode;
  onHide: () => void;
}

export const ChatPanel: FunctionComponent<ChatPanelProps> = ({
  initialWidth,
  className,
  show,
  stopAnimation,
  onHide,
  children,
  customBackground,
}) => {
  return (
    <PanelOverlay
      initialWidth={initialWidth}
      className={className}
      show={show}
      minWidth={350}
      stopAnimation={stopAnimation}
    >
      {customBackground && (
        <CustomBackground inert aria-hidden>
          {customBackground}
        </CustomBackground>
      )}
      <InnerPanelWrapper>
        <Header onHide={onHide} />
        {children}
      </InnerPanelWrapper>
    </PanelOverlay>
  );
};
